<template>
  <header role="banner">
    <div class="site-name">
      <a href="//assmat.maine-et-loire.fr" title="Retourner à l’accueil assmat.maine-et-loire.fr">
        <img loading="lazy" alt="Assistants maternels" :src="`${publicPath}titre-site.svg`" width="258" height="78" />
      </a>
      <span class="site-slogan">Le Département accompagne les assistants maternels</span>
    </div>
    <nav id="site-nav" class="site-nav" role="navigation" aria-label="Menu principal" :class="isOpened ? 'js-open' : ''">
      <button id="site-nav-button" class="site-nav-button" type="button" aria-label="Ouvrir / Fermer la navigation principale" aria-controls="main-nav" @click="toggleMainNav()" :aria-expanded="isOpened ? 'true' : 'false'">
        <span aria-hidden="true"></span>
      </button>
      <ul id="main-nav" class="site-nav-items" >
        <li><a href="//assmat.maine-et-loire.fr/assistant-maternel">Assistant maternel</a></li>
        <li><a href="//assmat.maine-et-loire.fr/parent">Parent</a></li>
        <li><a href="//assmat.maine-et-loire.fr/partenaire">Partenaire</a></li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      isOpened: false,
      isInitiallyVisible: false,
    }
  },
  mounted() {
    if (!this.isMobile()) {
      this.isInitiallyVisible = true
    }
  },
  methods: {
    toggleMainNav: function () {
      if (this.isOpened) {
        this.isOpened = false;
      } else {
        this.isOpened = true;
      }
      
      if(this.getWindowWidth() < 992) {
        document.body.classList.toggle('js-overflow-hidden');
      }
    }
  }
};
</script>

<style scoped>
@media (min-width: 768px) {
  #site-container > header {
    grid-template-rows: 1fr;
    height: 105px;
  }
}

@media (min-width: 992px) {
  #site-container > header {
     grid-template-rows: 1fr 1fr;
     height: 210px;
  }
}
</style>